import React, { Component } from 'react';
import { withRouter } from './withRouter.js';
import {Container, Jumbotron, Row, Col, Card, Button } from 'react-bootstrap';
import { FiExternalLink } from "react-icons/fi";
import zinat from './img/Zinat.jpg'
import tracy from './img/Tracy_Chen.jpg'
import fumeng from './img/FumengYang-2024-2-1.png'

class People extends Component { 



    render(){
        return(
            <>
            <h2  id='crew'> Teaching crew</h2>
            <Row>
              <Card className='people-card'>
               <Card.Img variant="top" src={fumeng} />
               <Card.Body>
                 <Card.Title><a href="https://www.fmyang.com" target='_blank' className='normal-a'>Fumeng <FiExternalLink /></a></Card.Title>
                 <Card.Text>
                Fumeng Yang <br/>
                 Instructor<br/>
                 Pronouns: she/her <br/>
                 Hours: W class to 4:30p<br/>
                 Classroom & IRB 2216
                 </Card.Text>
               </Card.Body>
               </Card>

               <Card className='people-card'>
               <Card.Img variant="top" src={tracy} />
               <Card.Body>
                 <Card.Title><a href="https://tracyyxchen.github.io/" arget='_blank' className='normal-a'>Tracy <FiExternalLink /></a></Card.Title>
                 <Card.Text>
                 Yuexi (Tracy) Chen <br/>
                 Teaching Assistant<br/>
                 Pronouns: she/her <br/>
                 Hours: Thu 2-3 Zoom <br/>
                 Links on Canvas
                 </Card.Text>
               </Card.Body>
               </Card>

               <Card className='people-card'>
               <Card.Img variant="top" src={zinat} />
               <Card.Body>
                 <Card.Title><a href='https://www.linkedin.com/in/kzintas/' arget='_blank' className='normal-a'>Zinat <FiExternalLink /></a></Card.Title>
                 <Card.Text>
                 Kazi Tasnim Zinat (Zinat) <br/>
                 Teaching Assistant<br/>
                 Pronouns: she/her <br/>
                 Hours: Thu 4-5p Zoom <br/>
                 Links on Canvas
                 </Card.Text>
               </Card.Body>
               </Card>
             </Row>
             </>
        )
    }
}



export default People;